import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall } from "./axiosMethodCalls";
const user = getUser();
const token = getToken();

//GET
export const getDepartment = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "departments/get",
            {
                requester: user,
                token: token,
                department_id: data.id,
                name: data.name,
                description: data.description,
                page: data.page
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createDepartment = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "departments/create",
            {
                requester: user,
                token: token,
                name: info.name,
                description: info.description,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateDepartment = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "departments/update",
            {
                requester: user,
                token: token,
                department_id: info.id,
                name: info.name,
                description: info.description,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteDepartment = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "departments/delete",
            {
                requester: user,
                token: token,
                department_id: id,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};